/**
 * Convert string coordinate to decimal degrees.
 * Supported formats:
 * - 45.12345
 * - "45.12345° N"
 * - "45°45'30\" N"
 * - "45 45 30"
 * - "N 45°45'"
 */
export function parseCoordinate(input) {
    if (typeof input === "undefined")
        return null;
    if (typeof input === "number")
        return input;
    const str = input.trim();
    // 1. Если просто число
    const plainNum = Number(str);
    if (!isNaN(plainNum))
        return plainNum;
    // 2. Десятичные градусы с направлением (e.g. "45.123° N" or "75.67890° W")
    const decimalDirRegex = /^([NSEW])?\s*([+-]?\d+(?:\.\d+)?)\s*°?\s*([NSEW])?$/i;
    const matchDecimal = str.match(decimalDirRegex);
    if (matchDecimal) {
        const [, hemi1, valueStr, hemi2] = matchDecimal;
        let value = parseFloat(valueStr);
        const hemi = (hemi1 || hemi2 || "").toUpperCase();
        if (["S", "W"].includes(hemi)) {
            value *= -1;
        }
        return value;
    }
    // 3. DMS формат (45°30'00" N, 45 30 00, и т.п.)
    const dmsRegex = /^([NSEW])?\s*([+-]?\d{1,3})(?:[°\s])?\s*(\d{1,3})?(?:['′\s])?\s*(\d{1,3}(?:\.\d+)?)?(?:["″]?)\s*([NSEW])?$/i;
    const match = str.match(dmsRegex);
    if (!match)
        return null;
    let [, hemi1, deg, min, sec, hemi2] = match;
    const degrees = parseFloat(deg || "0");
    const minutes = parseFloat(min || "0");
    const seconds = parseFloat(sec || "0");
    let decimal = degrees + minutes / 60 + seconds / 3600;
    const hemi = (hemi1 || hemi2 || "").toUpperCase();
    if (["S", "W"].includes(hemi)) {
        decimal *= -1;
    }
    return decimal;
}
